import { artifactTypes } from 'shared/constants/artifactTypes';

export const newsFeedTypes = {
  RATING_NEWS: 'RATING_NEWS',
  RESEARCH: 'RESEARCH',
  COMPANY_NEWS: 'COMPANY_NEWS',
};

export const newsToArtifactTypes = {
  RATING_NEWS: [artifactTypes.RATING_NEWS, artifactTypes.MONITORING_NOTES],
  RESEARCH: [artifactTypes.RESEARCH, artifactTypes.COMMENTARY],
  COMPANY_NEWS: [artifactTypes.COMPANY_NEWS],
};

export const newsFeedTypesLabels = {
  RATING_NEWS: 'Rating news',
  RESEARCH: 'Research news',
  COMPANY_NEWS: 'Company news',
};
